import React from "react";
import "../styles/Home.css";
import UsePageTitle from "../components/UsePageTitle";
import Footer from "../components/Footer/Footer";
import { Link } from "react-router-dom";

const TermsAndConditions = () => {
  UsePageTitle("Terms and Conditions | Bravix Group");

  return (
    <>
      <section className="privacy_policy_content_section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="privacy_policy_wrapper">
                <div className="privacy_policy_header">
                  <h2>TERMS AND CONDITIONS</h2>
                  <p className="last_updated">Effective Date: June 10, 2026</p>
                </div>

                <p className="privacy_intro">
                  Welcome to Bravix Group ("Bravix Group," "Company," "we,"
                  "our," or "us"). These Terms and Conditions govern your access
                  to and use of the Bravix Group website located at
                  bravixgroup.com and any related services provided by Bravix
                  Group.
                </p>

                <p className="privacy_intro">
                  By accessing or using our website and services, you agree to
                  be bound by these Terms and Conditions. If you do not agree
                  with these Terms, please do not use our website or services.
                </p>

                <div className="privacy_section">
                  <h3>1. About Bravix Group</h3>
                  <p>
                    Bravix Group is a recruiting and talent acquisition company
                    that connects employers with qualified candidates. Our
                    services may include recruiting, candidate sourcing, job
                    placement assistance, talent consulting, and related
                    communications.
                  </p>
                </div>

                <div className="privacy_section">
                  <h3>2. Use of the Website</h3>
                  <p>
                    You agree to use this website only for lawful purposes and
                    in accordance with these Terms.
                  </p>
                  <p>You agree not to:</p>
                  <ul>
                    <li>
                      Violate any applicable federal, state, or local laws or
                      regulations.
                    </li>
                    <li>Submit false or misleading information.</li>
                    <li>
                      Attempt to gain unauthorized access to any portion of the
                      website or related systems.
                    </li>
                    <li>
                      Use the website in a manner that could impair its
                      operation or security.
                    </li>
                    <li>
                      Transmit malicious software, viruses, or harmful code.
                    </li>
                  </ul>
                </div>

                <div className="privacy_section">
                  <h3>3. Information Submitted</h3>
                  <p>
                    By submitting information through our website, forms, job
                    applications, or other communication channels, you represent
                    that the information provided is accurate and complete.
                  </p>
                  <p>
                    You are responsible for maintaining the accuracy of any
                    information you provide to us.
                  </p>
                </div>

                <div className="privacy_section">
                  <h3>4. Recruiting Services</h3>
                  <p>
                    Bravix Group does not guarantee employment, job placement,
                    interviews, job offers, hiring decisions, or specific
                    business outcomes.
                  </p>
                  <p>
                    Employers retain sole discretion regarding hiring decisions,
                    and candidates remain solely responsible for evaluating
                    employment opportunities.
                  </p>
                </div>

                <div className="privacy_section">
                  <h3>5. Intellectual Property</h3>
                  <p>
                    All content on this website, including text, graphics,
                    logos, trademarks, images, software, and other materials, is
                    the property of Bravix Group or its licensors and is
                    protected by applicable intellectual property laws.
                  </p>
                  <p>
                    No content may be copied, reproduced, distributed, modified,
                    or used without prior written permission.
                  </p>
                </div>

                <div className="privacy_section">
                  <h3>6. SMS Communications Terms</h3>
                  <p>
                    By providing your mobile phone number and expressly opting
                    in, you agree to receive SMS text messages from Bravix Group
                    regarding recruiting and staffing services.
                  </p>
                  <p>SMS communications may include:</p>
                  <ul>
                    <li>Candidate outreach</li>
                    <li>Interview scheduling</li>
                    <li>Application status updates</li>
                    <li>Job opportunity notifications</li>
                    <li>Recruiting communications</li>
                    <li>Client communications</li>
                    <li>Appointment reminders</li>
                    <li>Service-related updates</li>
                  </ul>

                  <h4>Message Frequency</h4>
                  <p>
                    Message frequency varies depending on your interaction with
                    Bravix Group, recruiting activity, and communication
                    preferences.
                  </p>

                  <h4>Message and Data Rates</h4>
                  <p>
                    Message and data rates may apply according to your mobile
                    carrier plan.
                  </p>

                  <h4>Opt-Out Instructions</h4>
                  <p>
                    You may opt out of SMS communications at any time by
                    replying:
                  </p>
                  <p>
                    <strong>STOP</strong>
                  </p>
                  <p>
                    You will receive confirmation of your opt-out request and
                    will no longer receive SMS messages from Bravix Group unless
                    you provide renewed consent.
                  </p>

                  <h4>Help Instructions</h4>
                  <p>For assistance, reply:</p>
                  <p>
                    <strong>HELP</strong>
                  </p>
                  <p>or contact us using the information provided below.</p>

                  <h4>Consent Requirements</h4>
                  <p>
                    SMS consent is not a condition of employment consideration,
                    recruiting services, or any purchase.
                  </p>

                  <h4>Carrier Disclaimer</h4>
                  <p>
                    Wireless carriers are not responsible for delayed or
                    undelivered messages.
                  </p>
                </div>

                <div className="privacy_section">
                  <h3>7. Privacy</h3>
                  <p>
                    Your use of our services is also governed by our{" "}
                    <Link to="/privacy-policy">Privacy Policy</Link>. Information
                    collected through our website, forms, recruiting processes,
                    and communications will be handled in accordance with our
                    Privacy Policy.
                  </p>
                </div>

                <div className="privacy_section">
                  <h3>8. Third-Party Websites</h3>
                  <p>
                    Our website may contain links to third-party websites or
                    services. Bravix Group is not responsible for the content,
                    privacy practices, or operations of third-party websites.
                  </p>
                </div>

                <div className="privacy_section">
                  <h3>9. Disclaimer of Warranties</h3>
                  <p>
                    The website and services are provided on an "as-is" and
                    "as-available" basis.
                  </p>
                  <p>
                    Bravix Group makes no warranties, express or implied,
                    regarding the operation of the website, availability of
                    services, or accuracy of information provided through the
                    website.
                  </p>
                </div>

                <div className="privacy_section">
                  <h3>10. Limitation of Liability</h3>
                  <p>
                    To the fullest extent permitted by law, Bravix Group shall
                    not be liable for any indirect, incidental, consequential,
                    special, or punitive damages arising from the use of or
                    inability to use the website or services.
                  </p>
                </div>

                <div className="privacy_section">
                  <h3>11. Indemnification</h3>
                  <p>
                    You agree to indemnify and hold harmless Bravix Group, its
                    officers, employees, contractors, affiliates, and agents
                    from any claims, liabilities, damages, losses, and expenses
                    arising from your use of the website or violation of these
                    Terms.
                  </p>
                </div>

                <div className="privacy_section">
                  <h3>12. Termination</h3>
                  <p>
                    We reserve the right to suspend or terminate access to our
                    website or services at any time and for any lawful reason.
                  </p>
                </div>

                <div className="privacy_section">
                  <h3>13. Governing Law</h3>
                  <p>
                    These Terms and Conditions shall be governed by the laws of
                    the State of Florida and the laws of the United States,
                    without regard to conflict of law principles.
                  </p>
                </div>

                <div className="privacy_section">
                  <h3>14. Changes to These Terms</h3>
                  <p>
                    Bravix Group may update these Terms and Conditions at any
                    time. Changes will become effective upon posting to this
                    page with an updated effective date.
                  </p>
                </div>

                <div className="privacy_section privacy_contact">
                  <h3>15. Contact Information</h3>
                  <div className="contact_info">
                    <p>
                      <strong>Bravix Group</strong>
                    </p>
                    <p>Florida, United States</p>
                    <p>
                      Phone: <a href="tel:+18602953364">+1 860 295 3364</a>
                    </p>
                    <p>
                      Website:{" "}
                      <a
                        href="https://bravixgroup.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        bravixgroup.com
                      </a>
                    </p>
                  </div>
                  <p>
                    For questions regarding these Terms and Conditions, please
                    contact us through the contact information provided on our
                    website.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default TermsAndConditions;
